import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized-page',
  standalone: false,
  template: `
    <div class="unauthorized-container">
      <h2>Unauthorized Access</h2>
      <p>You are not authorized to access this page.</p>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 80vh;
      color: #c00;
    }
    h2 {
      font-size: 2rem;
      margin-bottom: 1rem;
    }
    p {
      font-size: 1.2rem;
    }
  `]
})
export class UnauthorizedPageComponent {}
